(() => {
  if (window.clownRefontePages) return;
  window.clownRefontePages = true;
  const init = (scope = document) => {
    scope.querySelectorAll('[data-cr-help-search]').forEach((input) => {
      if (input.dataset.ready) return;
      input.dataset.ready = 'true';
      const group = input.closest('.cr-pages');
      const rows = [...group.querySelectorAll('[data-cr-help-item]')];
      const status = group.querySelector('[data-cr-help-status]');
      input.addEventListener('input', () => {
        const query = input.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
        let count = 0;
        rows.forEach((row) => {
          const value = row.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
          row.hidden = !value.includes(query);
          if (!row.hidden) count++;
        });
        if (status) { status.hidden = count > 0; status.textContent = 'Aucune réponse pour cette recherche. Écris-nous à support@clown.art.'; }
      });
    });
    scope.querySelectorAll('[data-cr-sort]').forEach((select) => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.href);
      });
    });
    scope.querySelectorAll('[data-cr-legal-body]').forEach((body) => {
      if (body.dataset.ready) return;
      body.dataset.ready = 'true';
      const list = body.closest('.cr-page-legal')?.querySelector('[data-cr-toc]');
      if (!list) return;
      [...body.querySelectorAll('h2,h3')].forEach((heading, index) => {
        if (!heading.id) heading.id = `section-${body.id}-${index + 1}`;
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${heading.id}`;
        a.textContent = heading.textContent;
        li.append(a); list.append(li);
      });
      list.hidden = !list.children.length;
      if (!list.children.length) list.previousElementSibling.hidden = true;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* CLOWN · Collection / Histoire / École (refonte 06.10.2026) : filtres, tri, FAQ. Bloc indépendant, initialisé une fois. */
(() => {
  if (window.clownP3Pages) return;
  window.clownP3Pages = true;
  const init = (scope = document) => {
    scope.querySelectorAll('[data-p3-catalog]').forEach((catalog) => {
      if (catalog.dataset.p3Ready) return;
      catalog.dataset.p3Ready = 'true';
      const cards = [...catalog.querySelectorAll('.p3-card[data-p3-cat]')];
      const chips = catalog.querySelector('[data-p3-chips]');
      const visibleLabel = catalog.querySelector('[data-p3-visible]');
      const none = catalog.querySelector('[data-p3-none]');
      const counts = { all: cards.length };
      cards.forEach((card) => { counts[card.dataset.p3Cat] = (counts[card.dataset.p3Cat] || 0) + 1; });
      if (chips) {
        chips.querySelectorAll('[data-p3-count]').forEach((el) => { el.textContent = counts[el.dataset.p3Count] || 0; });
        chips.querySelectorAll('[data-p3-filter]').forEach((chip) => {
          if (chip.dataset.p3Filter !== 'all' && !counts[chip.dataset.p3Filter]) chip.hidden = true;
        });
        if (cards.length) chips.hidden = false;
      }
      const apply = (cat) => {
        let shown = 0;
        cards.forEach((card) => {
          const on = cat === 'all' || card.dataset.p3Cat === cat;
          card.hidden = !on;
          if (on) { shown++; card.classList.add('is-in'); }
        });
        catalog.querySelectorAll('[data-p3-group]').forEach((group) => {
          group.hidden = !group.querySelector('.p3-card:not([hidden])') && !group.querySelector('.p3-empty');
        });
        if (none) none.hidden = shown > 0;
        if (visibleLabel) visibleLabel.textContent = `${shown} produit${shown > 1 ? 's' : ''}`;
        chips?.querySelectorAll('[data-p3-filter]').forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.p3Filter === cat)));
      };
      chips?.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-p3-filter]');
        if (chip) apply(chip.dataset.p3Filter);
      });
      document.querySelectorAll('[data-p3-jump]').forEach((link) => link.addEventListener('click', () => apply(link.dataset.p3Jump)));
      if (visibleLabel && cards.length) visibleLabel.textContent = `${cards.length} produit${cards.length > 1 ? 's' : ''}`;
    });
    scope.querySelectorAll('[data-p3-sort]').forEach((select) => {
      if (select.dataset.p3Ready) return;
      select.dataset.p3Ready = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        if (select.value) url.searchParams.set('sort_by', select.value);
        else url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        window.location.assign(url.href);
      });
    });
    /* FAQ : un seul élément ouvert à la fois, hauteur animée. */
    scope.querySelectorAll('[data-p3-faq]').forEach((list) => {
      if (list.dataset.p3Ready) return;
      list.dataset.p3Ready = 'true';
      list.addEventListener('toggle', (event) => {
        const item = event.target;
        if (!(item instanceof HTMLDetailsElement) || !item.open) return;
        list.querySelectorAll('details[open]').forEach((other) => { if (other !== item) other.open = false; });
      }, true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
